var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVenteuniqueAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "#FF0032",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5627_799)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8041 15.9992L54.299 28.3288C55.3763 29.1735 56 30.4842 56 31.8464V52.4962C56 54.9863 53.9742 57.0001 51.4923 57.0001H20.5077C18.0129 57.0001 16 54.9735 16 52.4962V31.8464C16 30.4842 16.6237 29.1735 17.6881 28.3288L33.1959 15.9992C34.0052 15.3374 34.9974 15.0078 35.9897 15.0078C36.982 15.0078 37.9794 15.3374 38.8041 15.9992ZM50.7397 38.4928C47.4536 40.2567 42.0902 41.413 36 41.413C29.9098 41.413 24.5464 40.2567 21.2603 38.4928C20.7912 38.2585 20.2088 38.4928 20.1289 39.0361C20.0601 39.3486 20.104 39.6602 20.2603 39.9709C23.3634 45.9812 29.2474 50.0293 36 50.0293C42.7526 50.0293 48.6624 45.9812 51.7397 39.9709C51.9227 39.6336 51.9485 39.2833 51.8582 38.946C51.75 38.5958 51.4072 38.3846 51.0696 38.4001C50.9562 38.4052 50.8428 38.4336 50.7397 38.4928Z",
    fill: "#FF0032"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5627_799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 42,
    fill: "white",
    transform: "translate(16 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenteuniqueAppIcon);
export default __webpack_public_path__ + "static/media/venteunique-app-icon.046d6b1f13e4a4dac9651722c5616651.svg";
export { ForwardRef as ReactComponent };